import {
  useActions as useLoadActions,
  selectors as loadSelectors,
} from '../../store/FastCash/LogsSlice';

const useLogs = () => {
  const { load: loadLogs } = useLoadActions();
  const { getData, getLoadingState } = loadSelectors;
  const logs = getData();
  const logsLoadingState = getLoadingState();

  return {
    logs,
    loadLogs,
    logsLoadingState,
  };
};

export default useLogs;
